'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');
const components_display_TooltipWrapper_TooltipWrapper = require('../../display/TooltipWrapper/TooltipWrapper.cjs.js');
const components_display_Spinner_Spinner = require('../../display/Spinner/Spinner.cjs.js');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const root = "_root_mrx1c_1";
const innerWrap = "_inner-wrap_mrx1c_37";
const input = "_input_mrx1c_45";
const spinner = "_spinner_mrx1c_58";
const dot = "_dot_mrx1c_71";
const styles = {
	root: root,
	innerWrap: innerWrap,
	input: input,
	spinner: spinner,
	dot: dot
};

const getAriaLabel = (props) => {
  if (props["aria-label"]) {
    return props["aria-label"];
  }
  if (props.isLoading) {
    return "Loading";
  }
  return props.checked ? "On" : "Off";
};
const getTooltipContent = (props) => props.disabled && props.showDisabledTooltip ? "Disabled" : "";
const ToggleSwitch = ({ "aria-label": ariaLabel = void 0, checked = void 0, disabled = void 0, id = void 0, isLoading = false, name = void 0, onChange = () => {
}, showDisabledTooltip = true, value = void 0 }) => {
  const props = {
    "aria-label": ariaLabel,
    checked,
    disabled,
    id,
    isLoading,
    name,
    onChange,
    showDisabledTooltip,
    value
  };
  return React__default.default.createElement(components_display_TooltipWrapper_TooltipWrapper.TooltipWrapper, { content: getTooltipContent(props) }, ({ childProps }) => React__default.default.createElement(
    "label",
    Object.assign({}, childProps, { className: styles.root, "data-checked": props.checked || void 0, "data-disabled": props.disabled || void 0, "data-loading": props.isLoading || void 0, "data-zds": true }),
    React__default.default.createElement(
      "span",
      { className: styles.innerWrap, "data-zds": true },
      React__default.default.createElement("input", { "aria-disabled": props.disabled || props.isLoading, "aria-label": getAriaLabel(props), checked: props.checked, className: styles.input, disabled: props.disabled || props.isLoading, "data-zds": true, id: props.id, name: props.name, onChange: props.onChange, type: "checkbox", value: props.value }),
      props.isLoading && React__default.default.createElement(
        "span",
        { className: styles.spinner, "data-zds": true },
        React__default.default.createElement(components_display_Spinner_Spinner.Spinner, null)
      ),
      !props.isLoading && React__default.default.createElement("span", { "aria-hidden": "true", className: styles.dot, role: "presentation", "data-zds": true })
    )
  ));
};

exports.ToggleSwitch = ToggleSwitch;
//# sourceMappingURL=ToggleSwitch.cjs.js.map
